(() => {
  const getDisplayQuality = (entry) => {
    switch (true) {
      default:
        return 'n/a';

      case entry.quality === 'vr':
        return 'VR';

      case entry.quality === '4k':
        return '4K';

      case entry.quality === 'hd-full':
        return 'Full HD';

      case entry.quality === 'hd':
        return 'HD';

      case entry.quality === 'sd':
        return 'SD';

      case entry.quality === 'mobile':
        return 'Mobile';
    }
  };

  const bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return 'n/a';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    if (i === 0) return `${bytes} ${sizes[i]})`;
    return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
  };

  const handleDownloadError = (url, e) => {
    console.error(e);
    window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:hide');
    window.location = url;
    const errorMessage = e && (e.message || e.errmsg || 'server error');
    window.swinger.i18n()
      .then((i18n) => {
        window.swinger.snackbar.create({
          children: [
            {
              component: 'notification',
              data: {
                type: 'error',
                text: i18n('ui.shared.error', {
                  message: errorMessage,
                }),
              },
            },
          ],
        });
      })
      .catch(console.info);
  };

  const fileLink = document.createElement('a');

  const download = (url) => {
    window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:show');

    try {
      window.fetch(url, {
        credentials: 'include', // same-origin, omit, include
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => {
          if (response.status >= 400) {
            return Promise.reject(`server code ${response.status}`);
          }

          return response.json();
        })
        .then((response) => {
          if (url.indexOf('AMA') === -1) {
            return {
              url: response.url,
            };
          }

          return window.swinger.i18n().then((i18n) => {
            window.swinger.snackbar.create({
              children: [
                {
                  component: 'notification',
                  data: {
                    type: 'info',
                    text: i18n('ui.button-download.download-is-being-prepared'),
                  },
                },
              ],
            });

            return window.fetch(response.url).then((vxResponse) => vxResponse.blob()).then((blob) => ({
              url: response.url,
              blob,
            }));
          });
        })
        .then((result) => {
          const { url, blob } = result;
          const urlObject = new URL(url);
          const pathParts = urlObject.pathname.split('/');
          const fileName = pathParts.pop();
          fileLink.href = typeof blob !== 'undefined' ? window.URL.createObjectURL(blob) : url;
          fileLink.setAttribute('download', fileName);
          fileLink.click();

          let loadingIndictatorRevoked = false;
          const revokeLoadingIndicator = () => {
            if (loadingIndictatorRevoked) {
              return;
            }
            loadingIndictatorRevoked = true;
            window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:hide');
          };
          window.addEventListener('blur', revokeLoadingIndicator, { once: true });
          window.setTimeout(revokeLoadingIndicator, 30000);
        })
        .catch((e) => {
          handleDownloadError(url, e);
        });
    } catch (e) {
      handleDownloadError(url, e);
    }
  };

  window.swinger.observer.initialize('.swinger-button-dropdown[data-itemnumber]', (elem) => {
    const itemNumber = elem.getAttribute('data-itemnumber');
    const menu = elem.querySelector('.swinger-button-dropdown__menu');

    window.swinger.api.getItemDetails(itemNumber)
      .then((result) => {
        if (!menu) {
          return;
        }
        menu.innerHTML = '';
        result[0].availableResolutions.forEach((entry) => {
          const quality = getDisplayQuality(entry);
          const url = `${window.swinger.config.apiBase}${window.swinger.config.apiRoutes.download}?itemNumber=${itemNumber}&quality=${entry.quality}`;

          const menuitem = document.createElement('li');
          menuitem.setAttribute('role', 'menuitem');
          menuitem.classList.add('swinger-button-dropdown__menuitem');
          const item = document.createElement('a');
          item.classList.add('swinger-button');
          item.classList.add('swinger-button-dropdown__item');
          item.setAttribute('href', url);
          item.setAttribute('download', '');
          item.setAttribute('rel', 'nofollow');
          item.textContent = entry.fileSizeMb ? `${quality} (${bytesToSize(entry.fileSizeMb * 1024 * 1024)})` : quality;
          menuitem.appendChild(item);
          menu.appendChild(menuitem);
        });
      })
      .catch(console.info);
  }, false);

  document.addEventListener('click', (e) => {
    const elem = window.swinger.eventHub.getTarget(e).closest('a');

    if (!elem || !elem.matches('.swinger-button-dropdown__item')) {
      return;
    }

    download(elem.href);
    e.preventDefault();
  }, true);
})();
